export function initSubMenuFooterMobToggling() {
	const footerNav = document.querySelector(".footer-navigation");
	if (!footerNav) return;

	const buttons = footerNav.querySelectorAll(".title");
	if (!buttons.length) return;

	const items = footerNav.querySelectorAll(".item");

	footerNav.addEventListener("click", (e) => {
		const btn = e.target.closest(".title");
		if (!btn || !footerNav.contains(btn)) return;

		e.preventDefault();

		const currentItem = btn.closest(".item");
		if (!currentItem) return;

		const isActive = currentItem.classList.contains("active");

		items.forEach((item) => item.classList.remove("active"));
		if (!isActive) currentItem.classList.add("active");
	});

	const mq = window.matchMedia("(max-width: 768px)");

	mq.addEventListener("change", (e) => {
		if (!e.matches) {
			items.forEach((item) => item.classList.remove("active"));
		}
	});
}
